/**
 * Easebuzz platform fees for online top-ups (IATA agents), shown on the
 * Online Payment page. Rates exclude GST; settlement is T+1.
 */
export const PAYMENT_GATEWAY_NAME = 'Easebuzz';

export const PAYMENT_GATEWAY_FEES = [
  { mode: 'UPI', fee: '0.20%' },
  { mode: 'Credit Card (Visa, Master & Rupay)', fee: '1.90%' },
  { mode: 'Amex Card', fee: '2.90%' },
  { mode: 'Diners & Corporate Card', fee: '2.50%' },
  { mode: 'Debit Card (Visa, Master & Rupay)', fee: '1.00%' },
  { mode: 'UPI on Rupay Credit Card', fee: '2.00%' },
  { mode: 'Netbanking (All banks)', fee: '1.75%' },
  { mode: 'Mobile Wallets', fee: '1.90%' },
  { mode: 'BNPL', fee: '2.00%' },
  { mode: 'EMI on Credit Cards', fee: '2.00%' },
  { mode: 'Cardless EMI', fee: '2.00%' },
];

export const PAYMENT_GATEWAY_FEES_NOTE =
  '*Exclusive of GST // T+1 single Settlement';

/** UPI account behind the QR on the Offline Payment page. */
export const OFFLINE_UPI = {
  payee: 'M/S.SKYGEN HOSPITALITY SERVICES',
  upiId: 'MSSKYGENHOSPITALITYSERVICES.eazypay@icici',
};
